import mensagens from '@/util/mensagens'
import { BToast, BSpinner } from 'bootstrap-vue'
import constants from '@/util/constants'
import util from '@/util'
import { infraMixin } from '@/modules/infra/mixins'
import { mapState, mapActions } from 'vuex'
import imageStreamUtil from '@/components/layout/imageStream/js/util'
import { obterImagem } from '@/util/imagem'

export default {
  name: 'Validacao2faLogin',

  components: {
    'b-toast': BToast,
    'b-spinner': BSpinner
  },

  mixins: [infraMixin],

  computed: {
    ...mapState('auth', ['regrasLogin', 'logoCliente']),

    obterLogo () {
      return obterImagem('logo-office300.png')
    },

    dadosPendencia2fa () {
      if (util.valorVazio(this.regrasLogin)) {
        return {
          userId: null,
          tempoExpiracao: 30,
          tenant: null,
          origemSso: false
        }
      }

      const pendenciasLogin = JSON.parse(this.regrasLogin)

      return {
        userId: pendenciasLogin.userId || null,
        tempoExpiracao: pendenciasLogin.tempoExpiracao || 30,
        tenant: pendenciasLogin.tenant || null,
        origemSso: pendenciasLogin.origemSso === true
      }
    }
  },

  data: () => {
    return {
      dadosFormulario: {
        escritorio: ''
      },
      formulario: {
        codigo: ''
      },
      contador: 30,
      intervaloContador: null,
      retorno: {
        mensagemErro: '',
        mensagemSucesso: ''
      },
      flags: {
        efetuandoRequisicao: false
      },
      temLogoClienteNaSessao: false,
      callbackAposLoginSucesso: null
    }
  },

  mounted () {
    this.temLogoClienteNaSessao = !util.valorVazio(this.logoCliente)
    this.contador = this.dadosPendencia2fa.tempoExpiracao
    this.iniciarContador()
  },

  methods: {
    ...mapActions('auth', [
      'ActionSignOut',
      'ActionSetLoginStrategy',
      'ActionSetLogoCliente',
      'ActionSetEscritorio',
      'ActionSetTipoDeAcesso',
      'ActionSetPerfilUsuario',
      'ActionSetAcessoFinanceiro',
      'ActionSetAcessoFaturamento',
      'ActionSetNomeUsuarioLogado',
      'ActionSetAcessoEscritorio',
      'ActionSetFinanceiroContratado',
      'ActionSetFaturamentoContratado',
      'ActionSetCodigoFotoUsuario',
      'ActionSetEscritorioInadimplente',
      'ActionSetIdUsuarioLogado',
      'ActionSetDataCriacaoUsuarioLogado',
      'ActionSetEmailUsuario',
      'ActionSetSuporteOnlineHabilitado',
      'ActionSetIdEmpresa',
      'ActionSetOcultarOpcaoMenuBanco',
      'ActionSetRegrasLogin',
      'ActionSetAcessoRelatorios',
      'ActionSetRelatoriosContratado',
      'ActionSetAlertaStatusEmpresa'
    ]),

    async validarCodigo () {
      this.limparMensagem()

      try {
        this.definirFlagEfetuandoRequisicao(true)

        const resposta = await this.axios.post('/manager/login/validar-2fa', {
          code: this.formulario.codigo
        })

        if (resposta.data.success) {
          this.dadosFormulario.escritorio = this.dadosPendencia2fa.tenant
          const origemSso = this.dadosPendencia2fa.origemSso

          this.ActionSignOut()
          await this.definirDadosDeAcesso(resposta.data)

          this.ActionSetRegrasLogin('')
          await this.encaminharParaTelainicial(resposta.data, origemSso)
          return
        }

        this.retorno.mensagemErro = resposta.data.message || 'Não foi possível validar o código.'
        this.definirFlagEfetuandoRequisicao(false)
      } catch (e) {
        if (e.response && e.response.data && e.response.data.message) {
          this.retorno.mensagemErro = e.response.data.message
        } else {
          this.retorno.mensagemErro = mensagens.falhaComunicacaoServidor
        }

        this.definirFlagEfetuandoRequisicao(false)
      }
    },

    async reenviarCodigo () {
      this.limparMensagem()

      try {
        this.definirFlagEfetuandoRequisicao(true)

        const resposta = await this.axios.post('/manager/login/reenviar-2fa', {})

        if (resposta.data.success) {
          this.formulario.codigo = ''
          this.retorno.mensagemSucesso = resposta.data.message
          this.contador = this.dadosPendencia2fa.tempoExpiracao
          this.iniciarContador()
        } else {
          this.retorno.mensagemErro = resposta.data.message
        }

        this.definirFlagEfetuandoRequisicao(false)
      } catch (e) {
        util.criarAlertaToastDeErro(this, 'Aviso', mensagens.falhaServidorSalvandoDados)
        this.definirFlagEfetuandoRequisicao(false)
      }
    },

    async definirDadosDeAcesso (dadosLogin) {
      const escritorio = this.dadosFormulario.escritorio.trim()

      this.ActionSetLoginStrategy(dadosLogin.login_strategy)
      this.ActionSetLogoCliente(dadosLogin.f_client_logo)
      this.ActionSetEscritorio(escritorio)
      this.ActionSetTipoDeAcesso(dadosLogin.f_role)
      this.ActionSetPerfilUsuario(dadosLogin.f_profile)
      this.ActionSetAcessoFaturamento(dadosLogin.f_billing)
      this.ActionSetAcessoEscritorio(dadosLogin.f_office)
      this.ActionSetFaturamentoContratado(dadosLogin.f_billing_contract)
      this.ActionSetAcessoFinanceiro(dadosLogin.f_financial)
      this.ActionSetFinanceiroContratado(dadosLogin.f_financial_contract)
      this.ActionSetNomeUsuarioLogado(dadosLogin.f_user_name)
      this.ActionSetEmailUsuario(dadosLogin.user_mail)
      this.ActionSetIdUsuarioLogado(dadosLogin.user_id)
      this.ActionSetDataCriacaoUsuarioLogado(dadosLogin.user_create_date)

      const codigoFotoUsuario = await this.obterCodigoFotoUsuario(dadosLogin.f_photo)
      this.ActionSetCodigoFotoUsuario(codigoFotoUsuario)

      this.ActionSetEscritorioInadimplente(dadosLogin.escritorioInadimplente)
      this.ActionSetAcessoRelatorios(dadosLogin.f_reports)
      this.ActionSetRelatoriosContratado(dadosLogin.f_reports_contract)
      this.ActionSetAlertaStatusEmpresa(dadosLogin.alertaStatusEmpresa ?? null)
      this.ActionSetSuporteOnlineHabilitado(dadosLogin.onlineSupportEnabled)
      this.ActionSetIdEmpresa(dadosLogin.office_id)
      this.ActionSetOcultarOpcaoMenuBanco(dadosLogin.hideBankMenu)
    },

    async encaminharParaTelainicial (dadosLogin, origemSso = false) {
      const listaPerfisAcessoDiretoJuridico = this.obterListaPerfisAcessoDiretoJuridico()
      const perfilUsuario = dadosLogin.f_profile.toString()
      const perfilPodeAcessarDiretoJuridico = (listaPerfisAcessoDiretoJuridico.indexOf(perfilUsuario) !== -1)
      // quem entrou pelo provedor não tem senha local a definir no primeiro acesso
      const loginNaoRealizado = !origemSso && dadosLogin.f_status === constants.statusUsuario.loginNaoRealizado
      const rotaInicial = (loginNaoRealizado ? 'primeiroAcesso' : 'inicio')

      if (rotaInicial === 'inicio' && perfilPodeAcessarDiretoJuridico) {
        await this.redirecionarParaSistemaExterno(constants.urlSistemaExterno.juridico, false)
        this.ActionSignOut()
      } else {
        this.redirecionarParaManager(rotaInicial, () => {
          if (this.callbackAposLoginSucesso !== null) {
            this.callbackAposLoginSucesso()
          }
        })
      }
    },

    async obterCodigoFotoUsuario (streamFotoUsuario) {
      try {
        return await imageStreamUtil.obterCodigoBase64DoObjetoStream(streamFotoUsuario)
      } catch (e) {
        return null
      }
    },

    iniciarContador () {
      this.pararContador()

      this.intervaloContador = setInterval(() => {
        if (this.contador > 0) {
          this.contador--
        } else {
          this.pararContador()
        }
      }, 1000)
    },

    pararContador () {
      if (this.intervaloContador) {
        clearInterval(this.intervaloContador)
        this.intervaloContador = null
      }
    },

    limparMensagem () {
      this.retorno.mensagemErro = ''
      this.retorno.mensagemSucesso = ''
    },

    definirFlagEfetuandoRequisicao (status) {
      this.flags.efetuandoRequisicao = status
    },

    eventoLoginTeclaEnter (evento) {
      if (evento.keyCode === constants.teclado.enter) {
        this.validarCodigo()
      }
    }
  }
}
